import {
  CubeIcon,
  ExitIcon,
  MoonIcon,
  PersonIcon,
  QuestionMarkCircledIcon,
  SunIcon,
} from "@radix-ui/react-icons";
import {
  Button,
  DropdownMenu,
  Flex,
  IconButton,
  Popover,
  Skeleton,
  Tooltip,
} from "@radix-ui/themes";
import { useTheme } from "next-themes";
import { useState } from "react";
import { useMedia } from "react-use";
import { planogramInfoTunnel } from "@/features/planogram-viewer/planogram-tunnel";
import { logout } from "@/entities/session";
import { useStaffMeQuery } from "@/shared/api";
import { useAppDispatch } from "@/app/appStore";
import { useAuthRedirect } from "@/shared/hooks/useAuthRedirect";
import { appSession } from "@/shared/lib/storage";
import { Preferences } from "./preferences";
import { Link, useParams } from "react-router-dom";

export function Header() {
  const { data: staffMe, isLoading: isStaffMeLoading } = useStaffMeQuery();
  const { theme, setTheme } = useTheme();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { redirectToStoresAfterLogin } = useAuthRedirect();
  const { storeKey } = useParams();

  const onLogout = () => {
    setLoading(true);
    dispatch(logout())
      .unwrap()
      .then(() => {
        setLoading(false);
        appSession.removeItem();
        redirectToStoresAfterLogin();
      });
  };

  const isDesktop = useMedia("(min-width: 720px)");

  return (
    <header className="p-2 border-b border-gray-200 dark:border-[var(--gray-a7)]">
      <Flex justify="between" px="2">
        <Preferences />
        <Flex gap="4">
          {isDesktop && <planogramInfoTunnel.Out />}
          <Tooltip content="Toggle theme">
            <IconButton
              variant="ghost"
              size="1"
              color="gray"
              onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
            >
              {theme === "light" ? <SunIcon /> : <MoonIcon />}
            </IconButton>
          </Tooltip>
          {isDesktop ? (
            <IconButton variant="ghost" size="1" color="gray">
              <QuestionMarkCircledIcon />
            </IconButton>
          ) : (
            <Popover.Root>
              <Popover.Trigger>
                <IconButton variant="ghost" size="1" color="gray">
                  <QuestionMarkCircledIcon />
                </IconButton>
              </Popover.Trigger>
              <Popover.Content width="360px">
                <planogramInfoTunnel.Out />
              </Popover.Content>
            </Popover.Root>
          )}

          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <Button variant="ghost" size="1" color="gray">
                <PersonIcon />
                <Skeleton loading={isStaffMeLoading} className="min-w-20 h-4">
                  {staffMe?.result.first_name} {staffMe?.result.last_name}
                </Skeleton>
              </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content>
              <DropdownMenu.Item asChild>
                <Link to={`/stores/${storeKey}/3d-view`}>
                  <CubeIcon />
                  <span>3D View</span>
                </Link>
              </DropdownMenu.Item>
              <DropdownMenu.Item onClick={onLogout} disabled={loading}>
                <ExitIcon /> Logout
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </Flex>
      </Flex>
    </header>
  );
}
